export function getPercentage(value, percent){
    return (value*(percent/100))
}